import { ComponentType, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { styled } from '@mui/material';

import { BACKGROUND, PEARL, STROKE } from '../../Helpers/colors';
import Text from '../Text';

export const TabsContainer = styled('div')(() => ({
	display: 'inline-flex',
	padding: '2px',
	alignItems: 'center',
	borderRadius: '9px',
	backgroundColor: PEARL.TERTIARY,
	minHeight: '40px',
	flexWrap: 'wrap',
}));

interface TabProperties {
	selected: boolean;
}

export const Tab = styled('div')<TabProperties>(({ selected }) => ({
	display: 'flex',
	width: 'max-content',
	padding: '8px 16px',
	justifyContent: 'center',
	alignItems: 'center',
	gap: 8,
	borderRadius: '8px',
	boxShadow: selected ? `0px 1px 2px 0px ${STROKE.TERTIARY}` : 'none',
	backgroundColor: selected ? BACKGROUND.PRIMARY[100] : 'transparent',
	border: selected ? `0.5px solid ${STROKE.TERTIARY}` : 'none',
	position: 'relative',
	':after': {
		content: '""',
		height: '16px',
		width: '1px',
		position: 'absolute',
		top: 12,
		right: 0,
		backgroundColor: STROKE.TERTIARY,
	},
}));

const CustomTabs = ({
	headers,
	panels,
	onHeaderClick,
	className,
}: {
	className?: string;
	headers: string[];
	onHeaderClick?: () => void;
	panels: ComponentType[];
}) => {
	const [tab, setTab] = useState<number>(0);
	const [, setParams] = useSearchParams();

	const setTabType = (value: number) => {
		setTab(value);
		window.localStorage.removeItem('tab');
		const params = new URLSearchParams();
		setParams(params, { replace: true });
	};

	useEffect(() => {
		const savedTab = window.localStorage.getItem('tab');
		if (!savedTab || !headers || !headers.length) return;
		setTab(parseInt(savedTab));
	}, [headers]);

	return (
		<>
			<div className={className}>
				<TabsContainer onClick={onHeaderClick}>
					{headers &&
						headers.length > 0 &&
						headers.map((header, index) => (
							<Tab
								onClick={() => setTabType(index)}
								key={index}
								id={`${index}`}
								selected={index === tab}
								style={{ cursor: 'pointer' }}
							>
								<Text title={header} type="psm" fontWeight={index === tab ? 'semiBold' : 'medium'} />
							</Tab>
						))}
				</TabsContainer>
			</div>
			{panels &&
				panels.length > 0 &&
				panels.map((Panel, index) => (
					<div key={index} hidden={tab !== index}>
						{tab === index && <Panel />}
					</div>
				))}
		</>
	);
};

export default CustomTabs;
